import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ssoClientsKeys } from "Api/Queries/SsoClients/useSsoClientsQuery";
import {
  postSsoClientsClientIdSecret,
  type SsoClientSecretDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SsoClientSecretDto) => void;
  onError?: (error: unknown) => void;
};

export const useRotateSsoClientSecretMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((clientId: string) =>
      postSsoClientsClientIdSecret(clientId),
    ),
    onSuccess: (data: SsoClientSecretDto) => {
      queryClient.invalidateQueries({ queryKey: ssoClientsKeys.all });
      onSuccess?.(data);
    },
    onError,
  });
};
